import {gpEventKey} from '@app/components/game-player/analytics/constants'
import GameplayerEventType from '@app/components/game-player/analytics/event-type'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

interface GameCardClickInfo {
  gameCode: string
  categoryName: string
  layoutName?: string
}

function sendOnGameCardClick({gameCode, categoryName, layoutName}: GameCardClickInfo) {
  triggerAnalytics(GameplayerEventType.GameCardClicked, {
    [gpEventKey.gameCode]: gameCode,
    [gpEventKey.category]: categoryName,
    [gpEventKey.layout]: layoutName || categoryName,
  }).sendAll()
}

export default {sendOnGameCardClick}
